export { applyConditionalProperties } from './applyConditionalProperties'
